// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchBoxStyles } from "@conklin/Overrides/Widgets/Addresses/AddressBookSearchBox";
import IconSearch from "@conklin/XDL/Icons/IconSearch";
import { color } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

searchBoxStyles.searchText = {
    cssOverrides: {
        formInputWrapper: css`
            &&&& input {
                padding-right: 50px;
            }
        `,
    },
    iconProps: {
        src: IconSearch,
        css: css`
            &&& {
                pointer-events: all;
                cursor: pointer;
                &:hover {
                    color: ${color("common.ui10")};
                }
            }
        `,
    },
};
